import _ from 'lodash'
import * as eventUtils from 'Utilities/EventListener'

let setPrimaryNavMenuItemSlide = (readyEvent) => {
  let primaryNavItems = document.querySelectorAll('.primary-nav__menu-item');

  _.each(primaryNavItems, (navItem) => {
    navItem.addEventListener('click', (event) => {
      _.each(primaryNavItems, (element) => {
        element.querySelector('.primary-nav__sub-menu').classList.remove('primary-nav__sub-menu--active');
        element.classList.remove('primary-nav__menu-item--active');
      })

      navItem.classList.add('primary-nav__menu-item--active')
      navItem.querySelector('.primary-nav__sub-menu').classList.add('primary-nav__sub-menu--active')
    });
  });
}

eventUtils.addMultiEventsListener("DOMContentLoaded load page:load turbolinks:load", (event) => {
  setPrimaryNavMenuItemSlide(event)
});
